import React from "react";
const IconNewsletter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <path
      d="M29.5713 6.71387C31.7802 6.71394 33.5711 8.50497 33.5713 10.7139V13.0479C32.9925 12.8022 32.3559 12.666 31.6875 12.666C31.6486 12.666 31.6098 12.6665 31.5713 12.668V10.7139C31.5711 9.60954 30.6757 8.71394 29.5713 8.71387H18.4287C17.3243 8.71387 16.4289 9.60949 16.4287 10.7139V37.2852C16.4287 38.3897 17.3241 39.2852 18.4287 39.2852H29.5713C30.6758 39.2851 31.5713 38.3897 31.5713 37.2852V29.1152C32.2876 29.0443 32.9628 28.8351 33.5713 28.5156V37.2852C33.5713 39.4942 31.7804 41.2851 29.5713 41.2852H18.4287C16.2196 41.2852 14.4287 39.4943 14.4287 37.2852V10.7139C14.4289 8.50492 16.2197 6.71387 18.4287 6.71387H29.5713Z"
      fill="currentColor"
    />
    <rect
      x="20.5264"
      y="12.8574"
      width="21.5179"
      height="16.1384"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M42.0454 15.0979L32.3959 21.5309C31.7241 21.9788 30.8489 21.9788 30.1771 21.5309L20.5276 15.0979"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect x="22.2856" y="35.1426" width="3.42857" height="3.42857" rx="1.71429" fill="currentColor" />
  </svg>
);
export default IconNewsletter;
